import paths from "@icarius-router/paths";
import { numberComparatorMax2, numberFilterParams, createNumberFormatter } from "@icarius-table/number";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.typesOfBenefits],
        config: {
            headerName: getLocalizedString("benefitCode"),
            field: 'code',
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.typesOfBenefits],
        config: {
            headerName: getLocalizedString("benefitName"),
            field: 'name',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.typesOfBenefits],
        config: {
            headerName: getLocalizedString("active"),
            field: 'activeString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.typesOfBenefits],
        config: {
            headerName: getLocalizedString("accessMode"),
            field: 'modeString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.typesOfBenefits],
        config: {
            headerName: getLocalizedString("usageFrequency"),
            field: 'frequencyString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.typesOfBenefits],
        config: {
            headerName: getLocalizedString("requiredPoints"),
            field: 'points',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.typesOfBenefits],
        config: {
            headerName: getLocalizedString("benefitValue"),
            field: 'value',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.typesOfBenefits],
        config: {
            headerName: getLocalizedString("relatedPaymentConcept"),
            field: 'conceptString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.typesOfBenefits],
        config: {
            headerName: getLocalizedString("benefitMaximumBudget"),
            field: 'maxBenefitBudget',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
]